import { SelectedExperiences } from "./SelectedExperiences";
import {Source} from "./Source";

export interface GratuityPreference {
    addToReviewReminder: boolean;
    commentLabel: string;
    enabled: boolean;
    experiences: SelectedExperiences;
    message: string;
    options: GratuityPreferenceOption[];
    enabledSources: GratuitySource[];
}

export interface GratuityPreferenceOption {
    id?: string;
    algorithm: GratuityAlgorithm;
    amount: number;
}

export enum GratuityAlgorithm {
    PERCENT = "percent",
    ABSOLUTE = "absolute",
}

export enum GratuitySource {
    CHECKOUT = Source.CHECKOUT,
    OFFICE = Source.OFFICE
}
